const Throw = {
	NoProvider: (...params: any) => { throw Error('NO_PROVIDER') },
	NoProviderAsync: (...params: any) => { return Promise.reject('NO_PROVIDER') }
}

export default Throw;